import { onMounted, ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';

import liveReports from 'dashboard/api/liveReports';
import { useEmitter } from 'dashboard/composables/emitter';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export const useVoiceCallMetrics = (
  section,
  { includePresence = false } = {}
) => {
  const metrics = ref({});
  const isLoading = ref(false);
  let hasLoaded = false;
  let isFetching = false;
  let shouldRefetch = false;

  const fetchData = async () => {
    if (isFetching) {
      shouldRefetch = true;
      return;
    }

    isFetching = true;
    isLoading.value = !hasLoaded;
    try {
      const { data } = await liveReports.getVoiceCallMetrics(section);
      metrics.value = data;
      hasLoaded = true;
    } finally {
      isFetching = false;
      isLoading.value = false;
      if (shouldRefetch) {
        shouldRefetch = false;
        fetchData();
      }
    }
  };

  const refreshData = useDebounceFn(fetchData, 300);

  useEmitter(BUS_EVENTS.VOICE_CALL_UPDATED, refreshData);
  useEmitter(BUS_EVENTS.WEBSOCKET_RECONNECT, refreshData);
  if (includePresence) {
    useEmitter(BUS_EVENTS.AGENT_PRESENCE_UPDATED, refreshData);
  }

  onMounted(fetchData);

  return { metrics, isLoading };
};
